<template>
  <div class="delivery-proof-list">
    <loading :active.sync="loading" />

    <div class="delivery-proof-list__toolbar">
      <addProofOfDelivery :assId="this.assignmentId" />
    </div>

    <div class="delivery-proof-list__table">
      <v-data-table
        id="ListTable"
        hide-actions
        :headers="headers"
        :items="items"
      >
        <template slot="items" slot-scope="props">
          <td class="delivery-proof-list__description">
            {{ props.item.description || "-" }}
          </td>
          <td>
            {{ props.item.updatedAt ? getTime3(props.item.updatedAt) : "-" }}
          </td>
          <td>{{ props.item.uploadedBy || "-" }}</td>
          <td>
            <ul class="delivery-proof-list__docs">
              <li
                :key="i"
                v-for="(doc, i) in props.item.document"
                ref="documentList"
              >
                <a
                  :href="doc"
                  class="document-link"
                  v-if="doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'"
                  target="_blank"
                >
                  <img src="../../assets/pfd.png" height="40" width="32" />
                </a>
                <a :href="doc" class="document-link" target="_blank" v-else>
                  <img src="../../assets/docimg.webp" height="40" width="40" />
                </a>
              </li>
            </ul>
          </td>
          <td class="delivery-proof-list__reason">
            {{ props.item.rejectedReason || "-" }}
          </td>
          <td class="delivery-proof-list__action">
            <editProofOfDelivery :details="props.item" :assId="assignmentId" />
          </td>
        </template>
      </v-data-table>
    </div>

    <div class="delivery-proof-list__footer">
      <span class="delivery-proof-list__pages"
        >Total Pages - {{ totalPages }}</span
      >
      <PaginationButtons
        :url="`/dmsAdmin/viewProofOfDeliveryForAssignment`"
        :payload="payload"
        :callback="callback"
        :componentKey="componentKey"
        v-on:pagination-payload="paginationPayload"
      />
    </div>
    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
    <v-snackbar
      :timeout="3000"
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </div>
</template>
<script>
import _ from "lodash";
import { EventBus } from "../../event-bus.js";
import Loading from "vue-loading-overlay";
import { proofOfDeliveryList } from "@/constants/datatable-headers.js";
import SuccessDialog from "@/components/Common/SuccessDialog";
import ErrorBox from "@/components/Common/ErrorBox";
import moment from "moment";
import { StorageKeys, JobTypes, JobListTypes } from "../../constants/constants";
import { async } from "q";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import PaginationButtons from "@/components/Pagination/Pagination-New";
import addProofOfDelivery from "../Pop-ups/addProofOfDelivery";
import editProofOfDelivery from "../Pop-ups/editProofOfDelivery";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          this.workingCountry = key.value;
        }
      });
    }

    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "documents") {
        this.$router.push(`/jobs`);
      }
      this.workingCountry = val.value;
      this.loading = true;
    });
    this.payload = {
      skip: "0",
      limit: "15",
      assignmentId: this.assignmentId,
      workingCountry: this.workingCountry,
    };
    this.$eventBus.$on("delivery-proof-dialog", () => {
      this.componentKey += 1;
    });
    this.$eventBus.$on("stop-load", () => {
      this.loading = false;
    });

    this.JobTypes = JobTypes;
    if (!navigator.onLine) {
      this.loading = false;
      this.error = "Please check your internet connection";
      setTimeout(() => {
        this.error = "";
      }, 3000);
      return;
    }
  },
  components: {
    PaginationButtons,
    SuccessDialog,
    ErrorBox,
    Loading,
    addProofOfDelivery,
    editProofOfDelivery,
  },
  props: {
    loadingstop: Function,
    loader: Boolean,
    assignmentId: String,
  },

  data() {
    return {
      workingCountry: null,
      JobTypes: [],
      jobType: "",
      error: "",
      loading: true,
      dialog: false,
      dialog2: false,
      processing: false,
      x: {
        message: "",
        loading: true,
        success: false,
        menu: false,

        error: null,
        missingField: null,
      },
      search: "",
      componentKey: 0,

      totalPages: "",

      payload: {},

      headers: proofOfDeliveryList,
      items: [],
    };
  },
  watch: {},
  methods: {
    getTime3(date) {
      return moment(date).format("ll LT");
    },
    callback(res) {
      this.$eventBus.$emit("data", res.assignmentDetails[0]);
      this.loading = false;
      this.$eventBus.$emit("off-load");
      this.items = res.list;
      this.totalPages = Math.ceil(res.totalData / 15);
      //  window.scrollTo(0, 0);
    },

    paginationPayload(event) {
      this.payload = event;
      this.loading = true;
    },
  },
};
</script>
<style scoped>
.delivery-proof-list__toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.delivery-proof-list__toolbar ::v-deep .log {
  padding-bottom: 0 !important;
}

.delivery-proof-list__toolbar ::v-deep .v-btn {
  margin: 0 !important;
  text-transform: none;
}

.delivery-proof-list__table ::v-deep .v-table__overflow {
  overflow-x: auto;
  scrollbar-color: rgba(234, 122, 28, 0.45) transparent;
  scrollbar-width: thin;
}

.delivery-proof-list__table ::v-deep .v-table__overflow::-webkit-scrollbar {
  height: 0.375rem;
}

.delivery-proof-list__table ::v-deep .v-table__overflow::-webkit-scrollbar-thumb {
  background: rgba(234, 122, 28, 0.45);
  border-radius: 999px;
}

.delivery-proof-list__table ::v-deep table.v-table {
  min-width: 40rem !important;
  width: 100%;
}

.delivery-proof-list__table ::v-deep .v-datatable__progress {
  display: none;
}

.delivery-proof-list__table ::v-deep table.v-table thead th,
.delivery-proof-list__table ::v-deep table.v-table tbody td {
  padding: 0.5rem !important;
}

.delivery-proof-list__description,
.delivery-proof-list__reason {
  overflow-wrap: anywhere;
}

.delivery-proof-list__docs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0 !important;
}

.delivery-proof-list__docs .document-link {
  display: inline-flex;
  outline: none;
  text-decoration: none;
}

.delivery-proof-list__action ::v-deep .log {
  padding-bottom: 0 !important;
}

.delivery-proof-list__action ::v-deep .v-btn {
  margin: 0 !important;
}

.delivery-proof-list__footer {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.delivery-proof-list__pages {
  color: #ea7a1c;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.delivery-proof-list__footer ::v-deep .layout {
  flex: 0 0 auto;
  padding: 0 !important;
}

.delivery-proof-list__footer ::v-deep .pagination-back,
.delivery-proof-list__footer ::v-deep .pagination-forward {
  margin: 0.5rem 0 0 0.5rem !important;
}
</style>
